export class SubdomainRouter {
    config;
    constructor(config) {
        this.config = config;
    }
    getCurrentSubdomain() {
        const hostname = window.location.hostname;
        const baseDomain = this.config.baseDomain;
        const parts = hostname.split(".");
        const baseParts = baseDomain.split(".");
        if (parts.length <= baseParts.length) {
            return null;
        }
        if (parts.slice(-baseParts.length).join(".") !== baseDomain) {
            return null;
        }
        const subdomain = parts.slice(0, -baseParts.length).join(".");
        return subdomain === "app" || subdomain === "www" || subdomain === "auth" ? null : subdomain;
    }
    async lookupDomain(emailDomain) {
        const response = await fetch(`${this.config.apiBaseUrl}/v1/auth/domain-lookup?domain=${encodeURIComponent(emailDomain)}`, { credentials: "include" });
        if (!response.ok) {
            throw new Error("Failed to lookup domain");
        }
        return response.json();
    }
    async lookupSubdomain(subdomain) {
        const response = await fetch(`${this.config.apiBaseUrl}/v1/auth/subdomain-lookup?subdomain=${encodeURIComponent(subdomain)}`, { credentials: "include" });
        if (!response.ok) {
            if (response.status === 404) {
                return null;
            }
            throw new Error("Failed to lookup subdomain");
        }
        return response.json();
    }
    async shouldRedirectToSubdomain(emailDomain) {
        const result = await this.lookupDomain(emailDomain);
        if (result.hasSubdomain && result.redirectUrl) {
            return result.redirectUrl;
        }
        return null;
    }
    redirectToSubdomain(subdomain, path = "/") {
        const url = `https://${subdomain}.${this.config.baseDomain}${path}`;
        window.location.href = url;
    }
    redirectToAuthDomain(returnTo) {
        const url = new URL(`https://${this.config.authDomain}`);
        if (returnTo) {
            url.searchParams.set("returnTo", returnTo);
        }
        window.location.href = url.toString();
    }
    async handleEmailSubmit(email) {
        const emailDomain = email.split("@")[1]?.toLowerCase();
        if (!emailDomain) {
            throw new Error("Invalid email format");
        }
        const result = await this.lookupDomain(emailDomain);
        if (result.hasSubdomain && result.redirectUrl) {
            const currentSubdomain = this.getCurrentSubdomain();
            if (currentSubdomain !== result.subdomain) {
                return {
                    shouldRedirect: true,
                    redirectUrl: result.redirectUrl,
                };
            }
        }
        return {
            shouldRedirect: false,
            authMethods: result.authMethods,
            orgId: result.orgId,
        };
    }
    async initializeSubdomainAuth() {
        const subdomain = this.getCurrentSubdomain();
        if (!subdomain) {
            return null;
        }
        const config = await this.lookupSubdomain(subdomain);
        return config;
    }
    buildSsoLoginUrl(idpProvider, returnTo) {
        const redirectUri = `https://${this.config.authDomain}/callback`;
        const params = new URLSearchParams({
            response_type: "code",
            client_id: this.config.clientId,
            redirect_uri: redirectUri,
            scope: "email openid profile",
            identity_provider: idpProvider,
        });
        if (returnTo) {
            params.set("state", btoa(JSON.stringify({ returnTo })));
        }
        return `${this.config.cognitoDomain}/oauth2/authorize?${params.toString()}`;
    }
    autoRedirectToSso(idpProvider, returnTo) {
        const url = this.buildSsoLoginUrl(idpProvider, returnTo);
        window.location.href = url;
    }
}
export function createSubdomainRouter(config) {
    return new SubdomainRouter(config);
}
//# sourceMappingURL=subdomain-router.js.map